<template>
<div>
	<section>
		<div class="section-title" v-if="course != null">
            Report for duplicate program: {{ course.name }}
            <br />
           
        </div>

        <div class="row">
        	<div class="col-12">
               	<div class="text-right mb-4" @click="getCourse()">
               		<strong>Status:
               			<span :class="'text-' + status_class" class="loading">
               				{{ status }} 
               				<template v-if="status == 'Processing'">
               					<span>.</span><span>.</span><span>.</span>
               				</template>
               			</span> 
               		</strong>

               		<span>- <i>report id: <input id="hash" :value="hash" class="input-no-style"></i></span> 
               			<img width="25" src="../../../assets/images/icons/solid/copy.svg" class="pr-1 pl-1 m-1" @click="copyHash()"/>
               	</div>
                <div id="course-copy-logs">
                	<div v-for="log in logs" :class="'text-'+log.type">
	                	{{ log.message }}
	                </div>
                </div>
                
            </div><!--col-->
        </div><!--row-->
	</section>
</div>
</template>

<script>
	export default{
		data : function(){
			return {
				course_id : this.$route.params.id,
				hash : this.$route.params.hash,
				logs : [],
				course : null,
				timeout : null,
				status_class : 'info',
				status : ''
			}
		},

		created : function(){

			this.status = 'Processing';
			setTimeout(() => {
				this.getCourse();
			}, 5000);

			//this.getCourse();

			this.timeout = setInterval(() =>{
				this.getCourse();
			}, 15000);
		},

		destroyed : function(){
			clearTimeout(this.timeout);
		},

		methods : {
			getCourse : function(){
				var params = {
					id : this.course_id,
					filters : {
						logs : this.hash,
						page_loading : false
					}
				}

				this.$store.dispatch('getCourse', params).then((res) => {
					this.course = res.data.data;
					this.logs = res.data.data.logs;


					for(var i in this.logs){
						if(this.logs[i].message == 'Program duplicated successfully'){
							clearTimeout(this.timeout);
							this.status = 'Finished';
							this.status_class = 'success';
						}
					}
					//auto scroll down
					
					//var logs_container = document.getElementById('course-copy-logs');
					//logs_container.scrollTop = logs_container.scrollHeight;
					
					
				}).catch((error) => {
					console.log(error);
				});
			},

			copyHash : function(){
				var copyText = document.getElementById("hash");

				/* Select the text field */
				copyText.select(); 
				copyText.setSelectionRange(0, 99999); /*For mobile devices*/

				/* Copy the text inside the text field */
				document.execCommand("copy");

				/* Alert the copied text */
				alert("Copied report id to clipboard " + copyText.value);
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/sme/courses/SMECourseDuplicateComponent.vue